@if (totalPages > 1) {
  <nav class="academy-pagination" aria-label="Pagination">
    <div class="academy-pagination__group">
      <button
        class="academy-pagination__btn academy-pagination__btn--prev"
        (click)="onPageChange(currentPage - 1)"
        [disabled]="currentPage === 1"
        aria-label="Previous page"
        >
        <svg class="academy-pagination__icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <path d="M15.8334 9.99984H4.16675M4.16675 9.99984L10.0001 15.8332M4.16675 9.99984L10.0001 4.1665" stroke="currentColor" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="academy-pagination__label">Previous</span>
      </button>
      @for (page of pageNumbers; track page) {
        <button
          class="academy-pagination__btn academy-pagination__btn--page"
          [class.academy-pagination__btn--active]="page === currentPage"
          (click)="onPageChange(page)"
          [attr.aria-label]="'Page ' + page"
          [attr.aria-current]="page === currentPage ? 'page' : null"
          >
          {{ page }}
        </button>
      }
      <button
        class="academy-pagination__btn academy-pagination__btn--next"
        (click)="onPageChange(currentPage + 1)"
        [disabled]="currentPage === totalPages"
        aria-label="Next page"
        >
        <span class="academy-pagination__label">Next</span>
        <svg class="academy-pagination__icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <path d="M4.16675 9.99984H15.8334M15.8334 9.99984L10.0001 4.1665M15.8334 9.99984L10.0001 15.8332" stroke="currentColor" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  </nav>
}
